import Vue from "vue";
import Router from "vue-router";
import paths from "./paths";
import store from "../store";
import { FETCH_CURRENT_USER } from "../store/actions.type";

Vue.use(Router);
const router = new Router({
  base: "/",
  mode: "history",
  linkActiveClass: "active",
  routes: paths
});

let checkPermissions = (to, from, next) => {
  if (
    typeof to.meta.permission === "undefined" ||
    store.getters.hasPermission(to.meta.permission)
  ) {
    next();
  } else {
    next("/403");
  }
};

router.beforeEach((to, from, next) => {
  if (to.path !== "/login") {
    if (store.getters.isAuthenticated) {
      if (typeof store.getters.currentUser.username === "undefined") {
        store.dispatch(FETCH_CURRENT_USER).then(() => {
          checkPermissions(to, from, next);
        });
      } else {
        checkPermissions(to, from, next);
      }
    } else {
      next("/login");
    }
  } else {
    // go to login page
    next();
  }
});

export default router;
